import React, { createContext, useState, useEffect, useContext } from 'react'
import { getCurrentUser } from '../utils/utils'

export const UserContext = createContext()

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const fetchUser = async () => {
            const currentUser = await getCurrentUser()
            setUser(currentUser)
            setLoading(false)
        }

        fetchUser()
    }, [])

    const login = (userData, token) => {
        if (!userData.role) {
            console.warn('User role not provided in login data')
        }
        localStorage.setItem('authToken', token)
        setUser(userData)
    }

    const logout = () => {
        localStorage.removeItem('authToken')
        setUser(null)
    }

    const hasRole = (requiredRoles) => {
        // Special override for jimmy@company.com
        if (user && user.email === "team@happenings.dev") return true; // Special ovverride for testing logic
        
        if (!user || !user.role) return false
        if (!requiredRoles || requiredRoles.length === 0) return true

        // Check if user has any of the required roles
        return requiredRoles.some((role) => user.role.includes(role))
    }

    // You might also want a hasAllRoles function if you need to check for multiple required roles
    const hasAllRoles = (requiredRoles) => {
        if (!user || !user.role) return false
        if (!requiredRoles || requiredRoles.length === 0) return true

        // Check if user has all of the required roles
        return requiredRoles.every((role) => user.role.includes(role))
    }

    return (
        <UserContext.Provider
            value={{
                user,
                setUser,
                login,
                logout,
                loading,
                hasRole,
                hasAllRoles,
                companyId: user?.companyId,
                isAdmin: user?.isAdmin,
            }}
        >
            {children}
        </UserContext.Provider>
    )
}
